import React from 'react';
import styles from 'styles/layout/TeamsValuesSection.module.sass';
import { v4 as uuidv4 } from 'uuid';
import DynamicInfoContainer from 'components/common/DynamicInfoContainer';

/**
 * TeamsValuesSection
 * 
 * This section of the Teams page highlights the core values that drive the Zerone Analytics team.
 * It presents the company's guiding principles—such as purposeful data, innovation, partnership, and empathy—
 * in a visually engaging way using icons and descriptions.
 * 
 * The values are passed as structured data to the DynamicInfoContainer component, which handles the display.
 * 
 * Typical usage: Displayed on the Teams/About page to communicate company culture and values to users and potential recruits.
 */
const whatDrivesUs = {
  id: uuidv4(),
  title: 'What Drives Us',
  subtitle: 'Our core values guide every decision we make and every solution we build.',
  items: [
    {
      id: uuidv4(),
      icon: 'mdi:chart-pie',
      title: 'Data with Purpose',
      description: 'Every dataset we manage has real-world value. We believe in turning information into insight, and insight into impact. Our mission is to bridge the gap between raw data and meaningful action — empowering businesses, researchers, and decision-makers to make informed choices',
    },
    {
      id: uuidv4(),
      icon: 'streamline:industry-innovation-and-infrastructure-solid',
      title: 'Excellent Innovation',
      description: 'We believe data and technology can be used to fuel the advancement of industries, communities, and economies. And we believe such innovative solutions should be delivered in an excellent manner – in a truly outstanding way.',
    },
    {
      id: uuidv4(),
      icon: 'dashicons:admin-customizer',
      title: 'Accountable Partnership',
      description: 'We believe in being true partners to our clients; working with them shoulder to shoulder, delivering on our promises and holding ourselves accountable to the highest standards.',
    },
    {
      id: uuidv4(),
      icon: 'healthicons:medical-advice',
      title: 'Empathetic Service',
      description: 'We serve our employees, users, and partners with an enormous sense of responsibility and mindfulness to their needs, even those unarticulated.',
    },
  ],
};

const TeamsValuesSection: React.FC = () => (
  <section className={styles['values-section']}>
    <div className={styles['values-center-content']}>
      <DynamicInfoContainer info={whatDrivesUs} />
    </div>
  </section>
);

export default TeamsValuesSection;
